module.exports = {
    home: '首页',
    products: '产品介绍',
    suggest: '产品优势',
    process: '开通流程',
    sign_in: '登录',
    sign_up: '注册',
    network_income:'全网收益',
    partners:'合作伙伴',

}
